// Nowe egzemplarze czekające na zgodę właściciela (ścieżka `new`, docs/pwa/PLAN-ZROWNANIA.md etap 2;
// worker-go/api/urzadzenie.go). Stan poza Reactem jak zaproszenia (api/udostepnienia.ts): wczytywany przy starcie
// i po zdarzeniu SSE `konto` (`urzadzenia.oczekujace`), kafelki pokazuje ekran Urządzenia.
import { useSyncExternalStore } from "react";
import type { AccountEvent, OKReply, PendingOut, PendingReply } from "../gen/kontrakt";
import { zapytanie } from "./zaplecze";

let lista: readonly PendingOut[] = [];
const sluchacze = new Set<() => void>();
let wczytywanie: Promise<void> | null = null;

function ustaw(l: readonly PendingOut[]): void {
  lista = l;
  for (const f of sluchacze) f();
}

/** Wczytuje kolejkę (jedno zapytanie naraz); błąd - zostaje poprzednia lista. */
export function wczytajOczekujace(): Promise<void> {
  wczytywanie ??= zapytanie<PendingReply>("GET", "/api/urzadzenia/oczekujace")
    .then((o) => ustaw(o.oczekujace), () => undefined)
    .finally(() => { wczytywanie = null; });
  return wczytywanie;
}

/** Zdarzenie SSE `konto`: egzemplarz czeka, zgoda albo odebrał hasło (tu albo na innym telefonie). */
export function przyjmijZdarzenieOczekujacych(e: AccountEvent): void {
  if (e.rodzaj === "urzadzenia.oczekujace") void wczytajOczekujace();
}

/** Zgoda na TEN egzemplarz (odcisk z kafelka); `przyUrzadzeniu` - parowanie Bluetooth, zgoda może wyprzedzić urządzenie. */
export async function akceptuj(sn: string, identHash: string, przyUrzadzeniu = false): Promise<void> {
  await zapytanie<OKReply>("POST", "/api/urzadzenia/oczekujace/akceptuj",
    { sn, ident_hash: identHash, przy_urzadzeniu: przyUrzadzeniu });
  await wczytajOczekujace();
}

/** Wylogowanie: bez kolejki poprzedniego konta. */
export function wyczyscOczekujace(): void {
  ustaw([]);
}

function subskrybuj(f: () => void): () => void {
  sluchacze.add(f);
  return () => sluchacze.delete(f);
}

export function useOczekujace(): readonly PendingOut[] {
  return useSyncExternalStore(subskrybuj, () => lista);
}
